<template>
  <v-container fluid>
    <v-data-table
      :headers="tableHeaders"
      :items="items"
      no-data-text="Nessuna riga"
      no-results-text="Nessun risultato"
      aria-sort="Ciao"
    >
      <template v-slot:item="{item,index,headers}">
        <tr>
          <th v-for="(atr,ind) in headers" :key="ind">
            <span v-if="atr.value!='actions'">{{item[atr.value]}}</span>
            <span v-else>
              <v-btn icon @click="removeItem(index)">
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-btn icon @click="openModDialog(index)">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </span>
          </th>
        </tr>
        <tr></tr>
      </template>
      <template v-slot:footer>
        <v-flex d-flex>
          <v-spacer></v-spacer>
          <v-btn text @click="openNewDialog">
            <v-icon>mdi-plus</v-icon>Aggiungi riga
          </v-btn>
        </v-flex>
      </template>
    </v-data-table>
    <v-dialog v-model="dialog" max-width="60%">
      <v-card>
        <v-card-title>Inserisci riga</v-card-title>
        <v-card-text>
          <v-row cols="6">
            <v-col cols="6" v-for="(header,index) in headers" :key="index" xs6 sm6 md6 lg6 xl6>
              <h4>{{header.text}}</h4>
              <v-text-field outlined v-model="models[header.value]"></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-if="edit" text color="success" @click="modLine">Modifica</v-btn>
          <v-btn v-else text color="success" @click="newLine">Aggiungi</v-btn>
          <v-btn text color="error" @click="resetDialog">Esci</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
/*eslint-disable */
export default {
  props: {
    headers: Array,
    value: Array
  },
  data() {
    return {
      items: [],
      dialog: false,
      models: {},
      edit: false
    };
  },
  created() {
    this.items = this.value;
    for (let item of this.headers) {
      this.models[item.value] = "";
    }
  },
  methods: {
    openNewDialog() {
      this.dialog = true;
    },
    newLine() {
      this.dialog = false;
      let item = {};
      for (let index in this.models) {
        item[index] = this.models[index] != null ? this.models[index] : "";
      }
      this.items.push(item);
      this.$emit("input", this.items);
      this.resetDialog();
    },
    resetDialog() {
      this.dialog = false;
      for (let index in this.models) {
        this.models[index] = null;
      }
      this.edit = false;
    },
    removeItem(index) {
      this.items.splice(index, 1);
      this.$emit("input", this.items);
    },
    openModDialog(index) {
      this.edit = true;
      console.log(index);
      for (let ind in this.items[index]) {
        this.models[ind] = this.items[index][ind];
      }
      this.models.index = index;
      this.dialog = true;
    },
    modLine() {
      this.dialog = false;
      let index = this.models.index;
      delete this.models.index;
      for (let ind in this.models) {
        this.items[index][ind] = this.models[ind];
      }
      this.resetDialog();
      this.$emit("input", this.items);
    }
  },
  watch: {
    value: function() {
      this.items = [...this.value];
    }
  },
  computed: {
    tableHeaders: function() {
      let headers = [...this.headers];
      headers.push({
        text: "azioni",
        value: "actions"
      });
      return headers;
    }
  }
};
</script>

<style>
</style>